export const CHANGELOG = [
  {
    version: "3.9.5",
    date: "April 15, 2026",
    changes: [
      "[Internal] **DB Updates**",
    ],
  },
  {
    version: "3.9.4",
    date: "April 08, 2026",
    changes: [
      "[Fix] **Weapon Banner Rate-Up:** Resolved an issue where 'Eye of Perception' was incorrectly treated as a non-rate-up weapon. A background fix automatically restores the correct 75% rate-up chance for affected users.",
    ],
  },
  {
    version: "3.9.3",
    date: "February 27, 2026",
    changes: [
      "[Major Feature] **Dynamic Team Builder:** You can now create as many custom teams as you want, and delete old ones you no longer need. The team layout has been fully redesigned to emphasize your characters and their builds.",
      "[UI/UX] **Redesigned Team Cards:** Character icons are now used as striking backgrounds for their team slot. Equipped weapons and artifacts are now displayed over a beautiful frosted-glass backdrop, making your planned builds look incredible.",
    ],
  },
  {
    version: "3.9.2",
    date: "February 25, 2026",
    changes: [
      "[Fix] **Downtime Preview:** The preview section during server maintenance now correctly displays the upcoming banners based on the actual rotation schedule.",
      "[Improvement] **Banner Backgrounds:** Character banners now gracefully fall back to the generic 'Card' background if the high-resolution 'Wish' splash art is missing or still loading. It will seamlessly transition to the full wish art once downloaded.",
    ],
  },
  {
    version: "3.9.1",
    date: "February 23, 2026",
    changes: [
      "[Feature] **Chronicled Wish Regions:** The Chronicled Wish banner now dynamically displays its region (e.g., 'Mondstadt Chronicled Wish') in the banner title and history log.",
      "[Community] Added 'Thejonathon' to the Featured Community Creators showcase during downtime phases.",
    ],
  },
  {
    version: "3.9.0",
    date: "February 23, 2026",
    changes: [
      "[Internal] **Luna V Phase 1 Ready**",
    ],
  },
  {
    version: "3.8.4",
    date: "February 16, 2026",
    changes: [
      "[Fix] **Material Display:** Resolved an issue where materials with special characters (like colons) in their names were not being displayed in the character detail view.",
    ],
  },
  {
    version: "3.8.3",
    date: "January 25, 2026",
    changes: [
      "[Feature] **Chart Highlighting:** The 'Pity History' chart now reflects your pull outcomes with matching colors (Gold/Green/Red) and the special Capturing Radiance gradient.",
      "[Fix] **Character Banner Pool:** Removed standard 5-star weapons from the Character Event Banner pool. Obtaining a 5-star character now correctly limits the non-featured pool to standard characters only.",
    ],
  },
  {
    version: "3.8.2",
    date: "January 25, 2026",
    changes: [
      "[Feature] **History:** Added color highlighting for pull outcomes in the history list: Gold for Wins, Green for Guarantees, Red for Losses, and a special Shimmer for Capturing Radiance.",
      "[Feature] **C6 & R5 Capping:** Functional upgrades are now capped at Constellation 6 and Refinement 5.",
      "[Feature] **Masterless Starglitter:** 4★ and 5★ pulls now accurately award Starglitter based on your current constellation level (including extra glitters for C6 duplicates!).",
      "[Feature] **Total Obtained Count:** A new 'Total Obtained' statistic in the character inventory tracks every single pull, even after reaching C6.",
      "[Improvement] **Legacy Data Migration:** Automatically fixes accounts with 'overcapped' pending constellations while preserving the true pulling history.",
    ],
  },
  {
    version: "3.8.1",
    date: "January 19, 2026",
    changes: [
      "[Fix] **Weapon Banner:** Resolved a logic error in 10-pulls where obtaining a rate-up weapon would incorrectly set the status to 'guaranteed'.",
      "[Improvement] **Charts:** Chart labels are now intelligently abbreviated to improve readability and prevent layout issues.",
      "[Feature] **History:** 'Capturing Radiance' wins are now explicitly labeled as such in the history list.",
    ],
  },
  {
    version: "3.8.0",
    date: "January 12, 2026",
    changes: [
      "[Internal] **Luna IV Ready**",
    ],
  },
  {
    version: "3.7.1",
    date: "December 22, 2025",
    changes: [
      "[Feature] **Resource Insight:** Added a helpful display below the Genesis Crystals and Primogems inputs showing exactly how many Fates they are worth.",
      "[Localization] Added German translations for the new resource displays.",
    ],
  },
  {
    version: "3.7.0",
    date: "December 9, 2025",
    changes: [
      "[Special] **Thank You, Travelers!** As we all waiting for Version Luna IV, I want to take a moment to say a massive THANK YOU to everyone who uses this tracker. Your support, feedback, and passion are what keep this project alive. Here's to many more adventures in Teyvat!",
    ],
  },
  {
    version: "3.6.5",
    date: "December 7, 2025",
    changes: [
      "[Fix] **Persistence:** Fixed a critical bug where moving pulls between banners would not be saved correctly after a reload.",
      "[Improvement] **UI:** Added localized descriptions for the 'Move Batch' buttons.",
    ],
  },
  {
    version: "3.6.4",
    date: "December 4, 2025",
    changes: [
      "[Feature] **Resource UI:** Added visible labels to the '+' buttons for buying Fates with Starglitter, making their function clearer.",
      "[Feature] **Resource UI:** Added a display showing how many Fates your current Starglitter amount is worth.",
      "[Fix] **10-Pull Log:** Removed the incorrect '(Standard)' label from non-standard items in the 10-pull history log.",
    ],
  },
  {
    version: "3.6.3",
    date: "December 4, 2025",
    changes: [
      "[Feature] **Enhanced Wish History:** Added date, time, and friendly banner name (e.g., 'Ballad in Goblets') to all wish history entries.",
      "[Improvement] **Wish Simulator:** The 'Chronicled Wish' option is now correctly hidden when the banner is not active in the current phase.",
      "[Fix] **Wiki Image Proxy:** Implemented automatic rewriting of old image filenames to ensure all character art loads correctly.",
      "[Fix] **Stability:** Resolved a rare race condition in the toast notification system that could cause a crash during rapid interactions.",
    ],
  },
  {
    version: "3.6.2",
    date: "December 2, 2025",
    changes: [
      "[Fix] **Soft 404 Resolved:** Fixed an issue where the 'Welcome' popup was blocking Googlebot from indexing the site content. The popup is now automatically skipped for search engine crawlers.",
    ],
  },
  {
    version: "3.6.1",
    date: "December 1, 2025",
    changes: ["[INTERNAL] Improved Search Algorithm in Collection"],
  },
  {
    version: "3.6.0",
    date: "December 1, 2025",
    changes: ["[INTERNAL] Luna III Ready"],
  },
  {
    version: "3.5.1",
    date: "November 10, 2025",
    changes: ["[INTERNAL] DB Update, Preparing for Luna III"],
  },
  {
    version: "3.5.0",
    date: "October 10, 2025",
    changes: ["[INTERNAL] DB Update, Ready for Luna II"],
  },
  {
    version: "3.4.0",
    date: "September 30, 2025",
    changes: [
      "[Major Feature] **Revolutionary Goal Planner Overhaul!** The entire Goal Planner has been rebuilt for maximum accuracy, stability, and transparency.",
      "[Planner] **Introducing Triple-Scenario Calculation:** The planner now calculates a **Lucky**, **Average**, and **Worst-Case** scenario for your goals, giving you a complete picture from optimistic to guaranteed.",
      "[Planner] **Hyper-Realistic 'Average' Scenario:** The 'Average' calculation is no longer a simple formula. It's now powered by large-scale community statistics (~63 wishes for a guaranteed 5★, ~93 for a 50/50 win) for a much more accurate prediction of your likely outcome.",
      "[Planner] **C-State Aware Calculations:** The 'Average' scenario is now even smarter! It reads your current **Capturing Radiance (C-State)** and adjusts its predictions, knowing if your next 50/50 is a guaranteed win.",
      "[UI/UX] **Dedicated Goal Management:** Managing goals has been moved into a clean, dedicated modal. The main planner view is now a sleek, read-only summary, preventing accidental changes and improving clarity.",
      "[Fix] **Critical Planner State Corruption Resolved:** Fixed a long-standing, critical bug where the planner state could be wiped or corrupted after reloading the page, often caused by a race condition. The new architecture completely resolves this issue, ensuring your goals are always saved safely.",
      "[Documentation] **Full Transparency:** Added a new 'Goal Planner Scenarios' section to the in-app Guide, explaining exactly how each of the three scenarios is calculated so you can trust the numbers.",
      "[Internal] Refactored the planner's architecture to a pure Model-View-Controller (MVC) pattern, strictly separating data logic from the user interface. This makes the feature significantly more robust and reliable.",
    ],
  },
  {
    version: "3.3.1",
    date: "September 29, 2025",
    changes: [
      "[BUGFIX] Looking at the Problems why the Planner lost Goals. Changed Planner Style. Trying MCV for Planner",
    ],
  },
  {
    version: "3.3.0",
    date: "September 24, 2025",
    changes: [
      "[Major Feature] **Introducing the Advanced Goal Planner!** The Goal Planner has been completely rebuilt from the ground up to be a true strategic tool.",
      "[Planner] **Multi-Goal Planning:** You can now add multiple, distinct goals to a single plan. Want to save for a C1 character and their R1 signature weapon? Now you can plan for it all at once!",
      "[Planner] **Future-Proof Your Wishes:** The planner's item list now automatically includes 5-star characters and weapons from the *upcoming* banner rotation, allowing you to plan ahead with perfect accuracy.",
      "[Planner] **Precision Targeting:** The 'Copies' dropdown is now context-aware, showing C0-C6 for characters and R1-R5 for weapons.",
      "[Planner] **Smarter Than Ever:** The calculation engine has been overhauled. It now simulates the worst-case scenario sequentially for each goal, accurately using your **current, real-time pity and guarantee status** for maximum precision, even for future banners.",
      "[Improvement] **Intelligent 10-Pull Logging:** The 10-pull modal has been significantly reworked for accuracy. It now simulates your pity and guarantee status *as you add each item*. If you log a non-rate-up 4-star at pull #3, the item list for your next 4-star pull in the same 10-pull will now correctly only show the rate-up options. Works now also fpr 5-stars.",
      "[Fix] Corrected the worst-case calculation for the Chronicled Wish banner in the planner to use the proper 90 pity instead of 80.",
      "[Stability] Added a robust data migration for the planner. Accounts with the old planner data will now seamlessly and safely transition to the new multi-goal system upon loading.",
    ],
  },
  {
    version: "3.2.0",
    date: "September 18, 2025",
    changes: [
      "[Major Feature] **Introducing the Team Builder!** Plan your perfect Spiral Abyss or overworld teams directly in the new 'My Teams' section of the **Profile tab**.",
      "[Feature] **Seamless Collection Integration:** Add any character you've logged in 'My Collection' to your team slots. The builder only shows characters you actually own.",
      "[Feature] **Equip Your Arsenal:** Assign any weapon from your inventory to your characters. The system intelligently shows available weapons, preventing you from equipping the same weapon to multiple characters in the same team.",
      "[Feature] **Artifact Set Planning:** Assign up to two artifact sets to each character to visualize and plan your builds.",
      "[UI/UX] **Customizable Teams:** Create and rename multiple teams to keep your setups organized for different scenarios (e.g., 'Hyperbloom Squad', 'Exploration Team').",
      '[Fix] **Critical Startup Fix:** Resolved a major bug that could cause the app to crash on launch (`JSON.parse("undefined")`) if account data was missing or corrupted. The app is now significantly more robust.',
      "[UI/UX] The icons for equipped weapons and artifacts are now larger and positioned more dynamically on the team slot cards for better visibility.",
    ],
  },
  {
    version: "3.1.0",
    date: "September 17, 2025",
    changes: [
      "[Major Feature] **✨ Introducing the Wish Simulator!** Test your luck without spending a single Primogem. Find it in the 'Mini-Game' tab.",
      "[Feature] **Realistic Scenarios:** The simulator automatically uses your current pity and guarantee status from the main tracker for any banner, providing a true-to-life simulation of your next pulls.",
      "[UI/UX] **Step-by-Step Reveal:** Simulate up to 500 wishes and watch the results unfold with a beautiful card-flipping animation, 10 pulls at a time.",
      "[UI/UX] **Live Pity Updates:** After each 10-pull page, you'll see an updated summary of your new pity count and guarantee status, so you can track your luck as you go.",
      "[Improvement] The 'Mini-Game' tab now features a sub-navigation to switch between 'Slime Breaker' and the new 'Wish Simulator'.",
      "[Fix] Corrected the 4-star simulation logic for the Chronicled Wish banner to accurately reflect its unique probability rules (no rate-up guarantee).",
    ],
  },
  {
    version: "3.0.0",
    date: "September 16, 2025",
    changes: [
      "[Major Feature] **Multi-Account Support is here!** You can now manage multiple game accounts within the tracker. Each account has its own separate wish history, resources, collection, and settings.",
      "[Improvement] Added a new **Account Management** section in the Data Settings tab to easily add, rename, delete, and switch between your accounts.",
      '[Improvement] **Google Drive Sync now supports all accounts!** A single click on "Save to Drive" now securely backs up all your managed accounts in one file. "Load from Drive" restores all accounts at once.',
      "[Improvement] **JSON Im/Export is now Multi-Account aware.** Exporting your data now saves all accounts. Importing a multi-account file will restore all of them, while importing an old single-account backup will create a new, separate account for it.",
      "[Stability] The entire data loading and saving process has been overhauled to be more robust and prevent potential timing issues, ensuring a smooth and reliable experience when switching accounts.",
      "[Internal] Refactored the core state management to cleanly separate global settings from account-specific data, simplifying future updates.",
    ],
  },
  {
    version: "2.9.0",
    date: "September 12, 2025",
    changes: [
      "[Major Feature] **Clean URLs & Advanced Routing!** The entire app now uses a modern client-side router with clean URLs (e.g., `/guide/capturing-radiance`) instead of hashes, significantly improving navigation, link sharing, and SEO.",
      "[SEO] **Massive SEO Overhaul!** The page title, description, and social media previews (Open Graph & Twitter Cards) now update dynamically for each page. Shared links on platforms like Discord or X now look professional and informative.",
      "[SEO] The sitemap.xml has been rebuilt to include all new, specific URLs for key content like the guide pages and the collection, greatly improving discoverability for search engines.",
      "[SEO] Added a dedicated, visually-hidden H1 heading and introductory text to provide clear context for search engine crawlers without altering the clean UI.",
      '[UI/UX] The Capturing Radiance guide has been enhanced with a clearer explanation of the "bad luck protection" system and now includes an illustrative image.',
      "[UI/UX] The welcome modal and privacy guide now more strongly emphasize the tracker's core promises: 100% private, ad-free, and no data collection.",
      "[UI/UX] Tooltips (like for the C-State) are now mobile-friendly and appear on a long press.",
      "[Fix] Resolved all asset loading errors (CSS, JS, JSON, images) that occurred on sub-pages after the routing update by converting all resource paths to be absolute.",
      '[Fix] Corrected a JavaScript error that prevented the "My Collection" tab from opening when navigating to it via a direct URL.',
      "[Internal] Refactored deprecated `window.event` usage to align with modern JavaScript standards.",
    ],
  },
  {
    version: "2.8.0",
    date: "September 12, 2025",
    changes: [
      '[Major Feature] **Added "Capturing Radiance" Tracking!** The tracker now implements the hidden C-State system for the Character Event Banner. It automatically estimates, displays, and updates your C-State based on your 50/50 outcomes.',
      "[Feature] After a 50/50 win, a new modal will now ask if it was a special 'Capturing Radiance' win, allowing for precise calibration of the C-State.",
      "[UI/UX] A new 'C-State' indicator now appears next to the 50/50 status on the character banners, showing your current state (e.g., C-State: 1) with a tooltip explaining its meaning.",
      "[Feature] Added a manual C-State selector in the General Settings for users who already know their current state.",
      "[Documentation] The interactive Guide has been updated with a new section explaining the entire Capturing Radiance and C-State mechanic.",
      "[Fix] The C-State counter is now correctly capped at 3 and will not increase further, adhering to the system's rules.",
    ],
  },
  {
    version: "2.7.2",
    date: "September 11, 2025",
    changes: [
      "[Minigame Feature] **Elemental Slime Effects!** Slimes in 'Slime Breaker' now have unique on-defeat abilities, adding a new layer of strategy. Pyro slimes explode, Electro slimes chain lightning, Cryo slimes slow down balls, and Geo slimes have a breakable shield!",
      "[Minigame Feature] **New Achievements!** Added six new achievements for Slime Breaker, including milestones for highscore, reaching high rounds, and achieving massive hit combos (100, 500, and 1000 hits).",
      "[Minigame Polish] Added satisfying particle effects and a subtle screen shake when destroying slimes to significantly improve game feel.",
      "[Minigame Fix] Completely overhauled the minigame's save/load logic to be more robust. Issues with resuming a game after leaving the page, incorrect game-over states, and cross-device inconsistencies are now resolved.",
      "[Internal] The minigame's configuration and state management have been refactored to be more stable and self-contained, resolving a critical reference error.",
    ],
  },
  {
    version: "2.7.1",
    date: "September 10, 2025",
    changes: [
      "[Fix] Corrected an issue where character icons on the Chronicled Wish banner were not clickable. You can now open the detailed character info modal directly from this banner.",
      "[Fix] Standardized the date format for upcoming banner rotations in the internal data (e.g., '2025.09.30' to '2025-09-30'). This improves the reliability of date parsing and ensures banner transitions function correctly.",
    ],
  },
  {
    version: "2.7.0",
    date: "September 09, 2025",
    changes: [
      "[Major Feature] **Pre-Update Phases!** The tracker now automatically displays special UI states during the downtime before a major game update.",
      "[Feature] A **'Lull Phase'** view is now active when event banners end, showing a countdown to the server maintenance.",
      "[Feature] A **'Server Down'** view is now active during maintenance, showing a countdown to the new version launch and a preview of the upcoming banners.",
      "[Feature] **Content Creator Showcase!** During downtime, the banner cards now feature a randomized selection of YouTube community channels to watch while you wait.",
      "[Feature] Added a **'Surprise Me!'** button that opens a random video playlist from a featured creator on every click.",
      "[UI/UX] The upcoming character previews in the downtime view are now clickable, allowing users to view character details and pre-farm materials.",
      "[UI/UX] Improved the layout and styling of the lull/downtime info panels for better readability and presentation.",
      "[Fix] Resolved several critical errors that could occur when loading the app during a special banner phase with no active banner data.",
      "[Fix] Corrected the logic for the 'Surprise Me!' button to ensure it is truly random on every click and uses the correct YouTube playlist URL.",
    ],
  },
  {
    version: "2.6.1",
    date: "September 05, 2025",
    changes: [
      "[Major UI/UX] **Adaptive Input for Collection!** The inventory interaction has been completely overhauled to provide the best experience on every device.",
      "[Improvement] **On Mobile & Touch Devices:** Tapping an item now selects it and reveals its action buttons (like 'Edit'). A second tap opens the detailed info view. This makes interaction more precise and prevents accidental taps.",
      "[Improvement] **On Desktop (Mouse):** The fast, direct interaction is preserved. Hovering over an item highlights it, and a single click immediately opens the detailed info view or activates a button.",
      "[Fix] Corrected a critical bug where action buttons inside an inventory item (like 'Apply Constellation' or 'Refine') were unresponsive on the first click.",
      "[Internal] Implemented a robust input detection system that intelligently switches between touch- and mouse-optimized interaction models.",
    ],
  },
  {
    version: "2.6.0",
    date: "September 05, 2025",
    changes: [
      "[Feature] **Introducing Google Drive Sync (Beta)!** You can now optionally connect your Google Account in the Data settings to securely save and load your wish history to the cloud. Perfect for syncing your data across multiple devices.",
      "[Fix] Fixed a critical bug where action buttons in the 'My Collection' view (like 'Refine' or 'Edit') would become unresponsive or only trigger after a second click on another element. This was caused by the app stalling when an item icon could not be loaded, which is now resolved.",
      "[Improvement] Enhanced overall app stability and responsiveness, especially when working offline or with a slow connection, by adding image loading fallbacks. Missing icons will no longer block the user interface.",
      "[Internal] Refactored the event handling logic for item cards in the Collection to be more robust and prevent click conflicts between the card itself and the action buttons within it.",
    ],
  },
  {
    version: "2.5.1",
    date: "September 04, 2025",
    changes: [
      "[UI/UX] Moved the Guide to Menubar. Title is now only displayed in Guide Tab.",
      "[Fix] Fixed a significant layout bug on the 'Guide' tab where the content area would jump, resize, or slide off-screen when switching between topics. The transition is now a smooth and stable fade effect on all devices.",
    ],
  },
  {
    version: "2.5.0",
    date: "September 03, 2025",
    changes: [
      "[Feature] **Introducing the Traveler Profile!** You can now set your in-game name and choose between Aether and Lumine in the General settings.",
      "[UI/UX] Your profile is now displayed directly in the app! On desktop, it appears elegantly in the top-right corner of the header. On mobile devices, it's prominently featured at the top of the 'Profile' tab to save space.",
      "[UI/UX] Increased the size of the desktop profile icon for better visibility.",
      "[Fix] Corrected the image URLs for the Traveler icons (Aether & Lumine) to ensure they load correctly from the wiki proxy.",
      "[Internal] The responsive display logic for the new profile feature has been implemented with a robust, CSS-driven approach for maximum reliability.",
    ],
  },
  {
    version: "2.4.0",
    date: "September 03, 2025",
    changes: ["[Internal] DB update, all Chars done. Ready for 6.0"],
  },
  {
    version: "2.3.1",
    date: "September 02, 2025",
    changes: ["[Internal] DB update, 89/102 (+3) Chars done"],
  },
  {
    version: "2.3.0",
    date: "August 30, 2025",
    changes: ["[Internal] DB update, added missing Chars, prep for 6.0"],
  },
  {
    version: "2.2.2",
    date: "August 30, 2025",
    changes: [
      "[Major UI/UX Overhaul] **Responsive Desktop Layout!** The application now features a proper desktop view with a dedicated sidebar for navigation, providing a much-improved user experience on larger screens.",
      "[UI/UX] **Settings Converted to Main Tab.** The settings menu is no longer a disruptive modal window on desktop. It has been seamlessly integrated as a main tab for easier access and a cleaner workflow.",
      "[Fix] Fixed a layout shift issue within the new Settings tab. The content area no longer 'jumps' when switching between sub-tabs (General, Data, etc.), thanks to a CSS grid implementation.",
    ],
  },
  {
    version: "2.2.1",
    date: "August 30, 2025",
    changes: [
      "[Major Feature] **Full Progressive Web App (PWA) Support!** The tracker is now fully installable on mobile and desktop devices for an app-like experience. This includes complete offline access after your first visit and significantly faster loading times.",
      "[Improvement] **Dynamic PWA Theme Color:** The PWA's top status/title bar on mobile devices now dynamically changes its color to match the selected in-app theme (Pyro, Hydro, etc.). This creates a much more immersive and polished user experience.",
      "[Fix] Charts now correctly update their accent colors immediately when a new theme is selected, without requiring a page reload.",
    ],
  },

  {
    version: "2.2.0",
    date: "August 29, 2025",
    changes: [
      "[Major Feature] **Introducing 'My Collection'!** A new inventory system has been added to the Profile tab. You can now track all your 4 and 5-star characters and weapons in one place.",
      "[Feature] Items pulled are now automatically added to your collection. Duplicates for characters add a pending constellation, which you can activate manually – perfect for managing Bennett's C6!",
      "[Feature] A simple weapon refinement system has been implemented. Clicking on a weapon with available duplicates in your collection will consume a copy to increase its refinement rank.",
      "[Feature] You can now manually add characters (with their constellation) and weapons (with their refinement) to your collection.",
      "[UI/UX] The Profile tab now has a sub-navigation to switch between 'Fortune Analysis' and 'My Collection'.",
      "[UI/UX] Character icons in the collection are now clickable and open the detailed character information modal.",
      "[UI/UX] The collection view now features a subtle, elegant background to match the style of the banner cards.",
      "[Fix] Fixed a critical bug where the item selection list in the pull modals (single and 10-pull) did not respect the 'guaranteed' status, showing all items instead of just the correct one.",
      "[Fix] Corrected a major bug where the item selection list for the weapon and character banners could be incomplete or empty, preventing users from logging certain pulls.",
      "[Fix] Resolved an issue where the manual 'Toggle Guarantee' button was not working for any banner due to incorrect data attributes or a missing function.",
      "[Fix] Fixed a UI bug where canceling a 'path change' on the weapon banner would leave the dropdown in a visually incorrect state.",
    ],
  },

  {
    version: "2.1.1",
    date: "August 28, 2025",
    changes: ["[Internal] DB update"],
  },
  {
    version: "2.1.0",
    date: "August 27, 2025",
    changes: [
      "[Major Feature] **Introducing the 'Slime Breaker' Minigame!** Take a break from tracking wishes and smash some slimes in our new, built-in arcade game. You can find it under the 'Mini-Game' tab.",
      "[Major Improvement] **Frame-Rate Independent Gameplay:** The minigame now runs at the same consistent speed on all devices, from 60Hz phones to 144Hz gaming monitors. This was achieved by implementing a deltaTime-based game loop, ensuring a fair and smooth experience for everyone.",
      "[Feature] **Game Controls:** Added 'Restart Game' and 'Reset Highscore' buttons for better control over your gaming session.",
      "[Internal] Integrated the minigame state (score, highscore, active game) into the main application state, allowing it to be saved and loaded with the rest of your tracker data.",
    ],
  },
  {
    version: "2.0.1",
    date: "August 25, 2025",
    changes: [
      "[Major Feature] **Dynamic Profile Backgrounds!** Your Traveler's Fortune card now features a beautiful, dynamic background that reflects your gacha journey. Achieve an S-Rank Luck Score or show a strong elemental affinity to unlock special namecard backgrounds.",
      "[Improvement] **Expanded Statistics:** The profile analysis is now even more comprehensive, showing your 'Total Pulls' across all banners and your 'Average 4-Star Pity'.",
      "[Feature] **Your Personal Fortune Cookie:** Receive a unique, personalized insight based on your overall luck score at the bottom of the profile card.",
      "[UI/UX] **Redesigned Profile Layout:** The main statistics have been reorganized into a cleaner and more balanced grid for better readability on all devices.",
      "[Bugfix] Refined Bannerstats calculations to ensure accuracy across all banner types.",
      "[Internal] Refactored the `calculateProfileStats` function to be the central hub for all profile data, including the new dynamic background logic.",
      "[Internal] DB update",
    ],
  },
  {
    version: "2.0.0",
    date: "August 22, 2025",
    changes: [
      "[Major Feature] **Interactive Character Details:** Dive Deeper into Teyvat's Lore! You can now click on almost any item within the character detail view—including materials, recommended weapons, artifact sets, and even team members—to open a new, detailed information panel.",
      "[UI/UX Overhaul] The character detail modal has been completely redesigned for a more intuitive and visually stunning experience. It now features a prominent header with the character's icon, a more logical layout separating 'Equipment & Teams' from 'Farming Materials', and element-colored borders for recommended teammates.",
      "[Improvement] The description for characters is now beautifully highlighted directly under the header, giving it the feel of an in-game archive entry.",
      "[Improvement] Placeholder text for missing item details has been updated to the much more appropriate 'Soon™'. 😉",
      "[Fix] Corrected the description for talent materials to accurately state costs 'per Talent'.",
    ],
  },
  {
    version: "1.7.0",
    date: "August 22, 2025",
    changes: [
      "[Feature] Dive Deeper into Teyvat's Lore! You can now click on the icons of featured 5-star characters on the banners to open a new, detailed information panel. Discover recommended builds, materials, and more!",
      "[Coming Soon] This is just the beginning! We are working hard to gather and add detailed information for all characters. In future updates, you'll be able to click on 4-star characters, characters in your history, and eventually every character in the game.",
      "[Internal] Laid the foundational groundwork for the new character detail system, allowing for the gradual rollout of new character data.",
    ],
  },

  {
    version: "1.6.1",
    date: "August 21, 2025",
    changes: ["[+] Added Next Banner Info (Leak) for Phase 1 6.0"],
  },
  {
    version: "1.6.0",
    date: "August 19, 2025",
    changes: [
      "[Feature] Your Style, Your Teyvat! A new 'Background' option has been added to the General settings. You can now choose between the animated 'Icons', the classic 'Stars', or turn the background animation 'Off' completely.",
      "[UI/UX] The main navigation for 'Banners', 'Profile', and 'Resources' has been redesigned to perfectly match the sub-navigation style for a more cohesive and unified user experience.",
      "[UI/UX] The Settings button (gear icon) has been moved from the header and is now neatly integrated into the main navigation bar.",
      "[Fix] Greatly improved modal window behavior on high zoom levels and mobile devices. All modals, including Settings and Upcoming Banners, are now properly scrollable and will no longer have their content or buttons cut off.",
      "[Fix] The tabs within the Settings modal now wrap correctly on narrow screens, ensuring all options remain accessible.",
    ],
  },
  {
    version: "1.5.0",
    date: "August 19, 2025",
    changes: [
      "[Feature] Introducing Achievements! Unlock milestones like 'Novice Tracker' and 'Archivist of Teyvat' by consistently tracking your wishes. View your collection in the new 'Achievements' tab in the settings.",
      "[Feature] All-New 'Profile' Tab! Get a personalized 'Traveler's Fortune' analysis of your gacha journey. Discover your unique Luck Score, average 5-star and 4-star pity, 50/50 win rate, and your elemental & weapon affinities.",
      "[Improvement] The Settings menu has been completely redesigned into a sleek, tab-based modal for a cleaner and more organized experience.",
      "[Improvement] The Weapon Banner card now dynamically displays an icon for the selected weapon type in the top-right corner, just like the Character Banners.",
      "[Fix] Corrected a bug where background images for weapons with an apostrophe in their name (like Starcaller's Watch) would not load.",
      "[Internal] The item database has been updated to include element and weapon type data to power the new Profile analysis features.",
    ],
  },
  {
    version: "1.4.1",
    date: "August 18, 2025",
    changes: [
      "[Feature] Banners now update automatically! The app detects when a banner phase ends and seamlessly transitions to the next one from a predefined rotation schedule.",
      "[Improvement] The 'Upcoming Banners' modal is now fully dynamic and accurately previews the characters and weapons from the next scheduled rotation.",
      "[Improvement] Added element icons to the Upcoming Banners view for better character identification.",
      "[Improvement] Character Event Wish names (e.g., 'Astral Actuation') are now loaded dynamically with each rotation and are fully translatable.",
      "[Internal] Replaced static banner constants with a centralized `BANNER_ROTATIONS` array to streamline future updates.",
      "[Fix] Corrected an initialization error that could occur when rendering UI components before the banner data was fully loaded.",
    ],
  },
  {
    version: "1.4.0",
    date: "August 18, 2025",
    changes: [
      "[Feature] The Character Event Banner has been completely overhauled to support two distinct, switchable Event Wishes (Cahr 1 & Char 2), each with its own history and featured items.",
      "[Feature] Live countdown timers have been added to the Character and Weapon banners, showing exactly how much time is left.",
      "[Feature] A new 'Upcoming Banners' modal has been added, giving a sneak peek at the next rotation.",
      "[Improvement] The UI for all banners has been modernized. Dropdowns for featured items have been replaced with rich, dynamic displays.",
      "[Fix] The core logic for item selection pools has been rewritten to perfectly match in-game rules for all banners. This ensures the correct items are available for logging in both single and 10-pulls.",
      "[Fix] The 4-star pity on the Weapon Banner now correctly resets when a 5-star item is obtained, as it does in the game.",
      "[Fix] The 'Epitomized Path' guarantee on the Weapon Banner is now only activated if a course has been set. Pulling a 5-star without a set course no longer incorrectly grants a guarantee.",
    ],
  },
  {
    version: "1.3.2",
    date: "15. August 2025",
    changes: [
      "[Feature] Rarity stars (e.g., ★★★★★) are now displayed on the share card below the item name. Their color dynamically matches the selected theme.",
      "[Fix] Corrected a critical bug in the statistics calculation where 'Total Pulls' was showing an inflated number. The count is now accurate.",
      "[Improvement] Significantly improved the image quality on the share card. The circular item icon is now much sharper, and the background image is no longer stretched or distorted.",
    ],
  },
  {
    version: "1.3.1",
    date: "15. August 2025",
    changes: [
      "[Fix] Corrected a rendering issue where the downloaded share card image was horizontally stretched. Images now save with the correct proportions.",
      "[Fix] The circular preview image of the featured item is now correctly displayed on the share card again. This was caused by an incorrect CSS rule.",
    ],
  },
  {
    version: "1.3.0",
    date: "15. August 2025",
    changes: [
      "[Feature] Added a 'Create Share Image' feature! You can now generate and download a beautiful summary card of your banner stats to share on social media.",
      "[Feature] Interactive charts have been added to each banner. You can now switch between 'Pity History', 'Rarity Distribution', and 'Character/Weapon Ratio' charts.",
      "[Improvement] The statistics module has been completely overhauled. All banners now display a comprehensive set of stats, including average 4-star pity, luckiest/unluckiest pulls for both 4 and 5-stars, and type ratios.",
      "[Improvement] The chart system now intelligently selects the most data-rich chart to display by default.",
      "[Internal] Refactored the entire statistics and chart generation logic into a more robust and maintainable system.",
    ],
  },
  {
    version: "1.2.1",
    date: "14. August 2025",
    changes: [
      "[Fix] Corrected an issue where the color theme selector was not applying the selected theme after the recent performance update.",
    ],
  },
  {
    version: "1.2.0",
    date: "14. August 2025",
    changes: [
      "[Performance] Replaced the slow Tailwind CSS CDN with a high-speed, optimized build process. The app now loads significantly faster.",
      "[Performance] Minified all CSS assets, resulting in smaller file sizes and quicker load times.",
      "[Reliability] Implemented a professional-grade caching strategy. Users will now always receive the latest version of the app instantly after an update.",
      "[Fix] Corrected a Cross-Origin (CORB) error related to loading sound assets, which could cause the app to become unresponsive.",
      "[Internal] Overhauled the entire asset delivery pipeline for improved stability and future scalability.",
    ],
  },
  {
    version: "1.1.1",
    date: "14. August 2025",
    changes: [
      "[Reliability] Added a fallback mechanism to detect and handle version mismatches caused by browser caching.",
      "[SEO] Added sitemap.xml and robots.txt to improve search engine visibility.",
    ],
  },
  {
    version: "1.1.0",
    date: "14. August 2025",
    changes: [
      "[Fix] Corrected the 50/50 win/loss detection for featured characters.",
      "[Fix] The 4-star and 5-star pity systems are now correctly implemented as independent counters.",
      "[Improvement] Added robust validation for 10-pulls to prevent invalid input and pity rule violations.",
      "[Improvement] Unified all item selection dropdowns for a consistent user interface.",
      "[Improvement] The 'Log Single Pull' button is now correctly disabled when a 5-star pull is guaranteed.",
    ],
  },
  {
    version: "1.0.0",
    date: "12. August 2025",
    changes: ["[+] Initial release of the Pity Tracker!"],
  },
];
